import React, { useState } from "react";
import FuelChart from "../../fusionChart/fuelChart";
import SpeedChart from "../../fusionChart/speedChart";
import BatteryVoltage from "../../fusionChart/batteryVoltageChart";
import FuelADC from "../../fusionChart/fuelAdcChart";
import { connect } from "react-redux";
import { fetchFuelRequest } from "../../store/actions/fetchfuelsAction";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

const Dashboard = ({ ...props }) => {
  const [chart, setChart] = useState(1);

  const handleChart = (event) => {
    const chartType = event.target.value;
    setChart(chartType);
  };

  function changeChart() {
    if (chart === 2) {
      return <SpeedChart />;
    } else if (chart === 3) {
      return <BatteryVoltage />;
    } else {
      return <FuelADC />;
    }
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "1em",
        }}
      >
        <Select
          id="demo-simple-select-outlined"
          defaultValue={1}
          value={chart}
          onChange={handleChart}
          style={{
            background: "#651fff ",
            height: "45px",
            width: "180px",
            borderRadius: "4px",
            color: "#FFFFFF",
            padding: "0 0.5em",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <MenuItem value={1}>Fuel Chart</MenuItem>
          <MenuItem value={2}>Speed Chart</MenuItem>
          <MenuItem value={3}>Battery Voltage Chart</MenuItem>
          <MenuItem value={4}>Fuel ADC Chart</MenuItem>
        </Select>
      </div>
      {chart === 1 ? <FuelChart /> : changeChart()}
    </>
  );
};

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
  fuelSubmit: ({ requestData }) => dispatch(fetchFuelRequest({ requestData })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
